/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FreeCoreTextbookSubtopicDetailViewQueryVariables = {
    subtopicId: string;
};
export type FreeCoreTextbookSubtopicDetailViewQueryResponse = {
    readonly subtopic: {
        readonly worksheetJsx: {
            readonly transpiledJsx: string | null;
        };
        readonly title: string;
        readonly " $fragmentRefs": FragmentRefs<"FreeTextbookJsxLessonContainer_subtopic">;
    } | null;
};
export type FreeCoreTextbookSubtopicDetailViewQuery = {
    readonly response: FreeCoreTextbookSubtopicDetailViewQueryResponse;
    readonly variables: FreeCoreTextbookSubtopicDetailViewQueryVariables;
};



/*
query FreeCoreTextbookSubtopicDetailViewQuery(
  $subtopicId: ID!
) {
  subtopic(id: $subtopicId) {
    ...FreeTextbookJsxLessonContainer_subtopic
    worksheetJsx {
      transpiledJsx
      id
    }
    title
    id
  }
}

fragment FreeTextbookJsxLessonContainer_subtopic on FreeTextbookSubtopic {
  rslJsx {
    id
    pdfAvailable
    pdfUrl
    transpiledJsx
    locale
  }
  rslTeacherNoteJsx {
    id
    transpiledJsx
    locale
  }
  investigationJsx {
    id
    transpiledJsx
    locale
  }
  investigationTeacherNoteJsx {
    id
    transpiledJsx
    locale
  }
  solidifyLessonJsx {
    id
    pdfAvailable
    transpiledJsx
    pdfUrl
  }
  solidifyTeacherNoteJsx {
    transpiledJsx
    pdfAvailable
    pdfUrl
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "subtopicId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "subtopicId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "transpiledJsx",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pdfAvailable",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pdfUrl",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locale",
  "storageKey": null
},
v8 = [
  (v4/*: any*/),
  (v2/*: any*/),
  (v7/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FreeCoreTextbookSubtopicDetailViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FreeTextbookSubtopic",
        "kind": "LinkedField",
        "name": "subtopic",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Worksheet",
            "kind": "LinkedField",
            "name": "worksheetJsx",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FreeTextbookJsxLessonContainer_subtopic"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FreeCoreTextbookSubtopicDetailViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FreeTextbookSubtopic",
        "kind": "LinkedField",
        "name": "subtopic",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RetrofittedStudentLesson",
            "kind": "LinkedField",
            "name": "rslJsx",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v2/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RetrofittedStudentLessonTeacherNote",
            "kind": "LinkedField",
            "name": "rslTeacherNoteJsx",
            "plural": false,
            "selections": (v8/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Investigation",
            "kind": "LinkedField",
            "name": "investigationJsx",
            "plural": false,
            "selections": (v8/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InvestigationTeacherNote",
            "kind": "LinkedField",
            "name": "investigationTeacherNoteJsx",
            "plural": false,
            "selections": (v8/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SolidifyLesson",
            "kind": "LinkedField",
            "name": "solidifyLessonJsx",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v2/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SolidifyTeacherNote",
            "kind": "LinkedField",
            "name": "solidifyTeacherNoteJsx",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Worksheet",
            "kind": "LinkedField",
            "name": "worksheetJsx",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d6953a3723e9852c984247c4e7a3a822",
    "id": null,
    "metadata": {},
    "name": "FreeCoreTextbookSubtopicDetailViewQuery",
    "operationKind": "query",
    "text": "query FreeCoreTextbookSubtopicDetailViewQuery(\n  $subtopicId: ID!\n) {\n  subtopic(id: $subtopicId) {\n    ...FreeTextbookJsxLessonContainer_subtopic\n    worksheetJsx {\n      transpiledJsx\n      id\n    }\n    title\n    id\n  }\n}\n\nfragment FreeTextbookJsxLessonContainer_subtopic on FreeTextbookSubtopic {\n  rslJsx {\n    id\n    pdfAvailable\n    pdfUrl\n    transpiledJsx\n    locale\n  }\n  rslTeacherNoteJsx {\n    id\n    transpiledJsx\n    locale\n  }\n  investigationJsx {\n    id\n    transpiledJsx\n    locale\n  }\n  investigationTeacherNoteJsx {\n    id\n    transpiledJsx\n    locale\n  }\n  solidifyLessonJsx {\n    id\n    pdfAvailable\n    transpiledJsx\n    pdfUrl\n  }\n  solidifyTeacherNoteJsx {\n    transpiledJsx\n    pdfAvailable\n    pdfUrl\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '1227fe87c7a9f7f00d933efb35a5d052';
export default node;
